var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 4.66666V18.6667C9.33301 19.2855 9.57884 19.879 10.0164 20.3166C10.454 20.7542 11.0475 21 11.6663 21H20.9997C21.6185 21 22.212 20.7542 22.6496 20.3166C23.0872 19.879 23.333 19.2855 23.333 18.6667V8.44899C23.333 8.13815 23.2708 7.83044 23.1502 7.54395C23.0296 7.25745 22.853 6.99794 22.6307 6.78066L18.7632 2.99833C18.3273 2.5721 17.7418 2.3334 17.1322 2.33333H11.6663C11.0475 2.33333 10.454 2.57916 10.0164 3.01675C9.57884 3.45433 9.33301 4.04782 9.33301 4.66666V4.66666Z",
    stroke: "#585858",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 21V23.3333C18.6665 23.9522 18.4207 24.5457 17.9831 24.9832C17.5455 25.4208 16.952 25.6667 16.3332 25.6667H6.99984C6.381 25.6667 5.78751 25.4208 5.34992 24.9832C4.91234 24.5457 4.6665 23.9522 4.6665 23.3333V10.5C4.6665 9.88115 4.91234 9.28766 5.34992 8.85007C5.78751 8.41249 6.381 8.16666 6.99984 8.16666H9.33317",
    stroke: "#585858",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.7b78affce4d3d60540d1eccda8e2e0cc.svg";
export { ForwardRef as ReactComponent };